module.exports = require("./su-Latn.js");